import styled from '@emotion/styled';

export const Column = styled.div<{ width?: string; padding?: string }>`
  width: ${props => props.width};
  display: flex;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  column-gap: 8px;
  padding: ${props => props.padding ?? '0'};
  align-items: center;
`;
